import { createContext, useContext } from 'react';
/** @type {import('./types').ButtonGroupContext} */

var defaultContext = {};
export var ButtonGroupContext = /*#__PURE__*/createContext(defaultContext);
export var useButtonGroupContext = function () {
  return useContext(ButtonGroupContext);
};